<template>
  <b-card title="واریز سود حساب">
    <b-row>
      <b-col>
        <b-form-group label="حساب:">
          <b-form-select :options="banks" v-model="profit.bankid">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="ماه:">
          <b-form-select :options="months" v-model="profit.month">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="مبلغ:">
          <b-form-input v-model="profit.amount"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="success" @click="SaveProfit">ذخیره</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
export default {
  name: "GetProfit",
  data() {
    return {
      banks: [],
      profit: {
        amount: 0,
        bankid: 0,
        month: "",
      },
      months: [
        {
          text: "فروردین",
          value: "فروردین",
        },
        {
          text: "اردیبهشت",
          value: "اردیبهشت",
        },
        {
          text: "خرداد",
          value: "خرداد",
        },
        {
          text: "تیر",
          value: "تیر",
        },
        {
          text: "مرداد",
          value: "مرداد",
        },
        {
          text: "شهریور",
          value: "شهریور",
        },
        {
          text: "مهر",
          value: "مهر",
        },
        {
          text: "آبان",
          value: "آبان",
        },
        {
          text: "آذر",
          value: "آذر",
        },
        {
          text: "دی",
          value: "دی",
        },
        {
          text: "بهمن",
          value: "بهمن",
        },
        {
          text: "اسفند",
          value: "اسفند",
        },
      ],
    };
  },
  methods: {
    SaveProfit() {
      httpHelper.postData("saveProfit", this.profit).then((res) => {
          this.$router.push("/documents");
      });
    },
  },
  mounted() {
    httpHelper.getData("getBanks").then((res) => {
      this.banks = res.result.map((element) => {
        return {
          value: element.detail_id,
          text: "(" + element.code + ")" + element.name,
        };
      });
    });
  },
};
</script>